import { forwardRef } from 'react';
import styled from 'styled-components';

import noop from 'utils/noop';
import { ConditionTriggerButton } from '../TriggerButton';
import { ConditionDateRangeProps } from './types';
import { isNotNullDateRange } from './utils';

const StyledConditionTriggerButton = styled(ConditionTriggerButton)`
  max-width: unset;
`;

export const ConditionDateRangePickerTriggerButton = forwardRef<
  HTMLButtonElement,
  ConditionDateRangeProps
>(({ value: dateRange, placeholder, ...props }, ref) => {
  const isEmpty = !isNotNullDateRange(dateRange);
  return (
    <StyledConditionTriggerButton onClick={noop} innerRef={ref} isEmpty={isEmpty} {...props}>
      {isEmpty ? placeholder : `${dateRange?.startDate || ''} - ${dateRange?.endDate || ''}`}
    </StyledConditionTriggerButton>
  );
});
